import React from "react";
import { SignupModal } from "./SignupModal";

/**
 * Håller öppet/stängt-läget för anmälningsmodalen. Knapparna renderas av
 * Razor i flera .cshtml-filer, så klicken fångas via delegering på document
 * i stället för att varje knapp får en egen React-rot.
 */
export default function SignupModalHost(): React.JSX.Element | null {
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    const onClick = (event: MouseEvent): void => {
      const target = event.target as HTMLElement | null;
      if (!target?.closest("[data-breaks-signup]")) return;
      event.preventDefault();
      setIsOpen(true);
    };

    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  const close = React.useCallback((): void => setIsOpen(false), []);

  // Modalen avmonteras vid stängning så att ModalShell hinner städa upp
  // body-klassen och lämna tillbaka fokus till knappen som öppnade den.
  if (!isOpen) return null;

  return <SignupModal onClose={close} />;
}
